import { createSelector } from 'reselect';

import { AppState } from '../../../../../../store/models/app-state';

const demandsState = (state: AppState) => state.demandDetail;

export const demandDetailFeedbackDataSelector = createSelector(demandsState, state => state.feedback.stepData);

/** What the step compares against to decide whether anything is unsaved. */
export const demandDetailFeedbackBaselineSelector = createSelector(demandsState, state => state.feedback.baseline);
export const demandDetailFeedbackDetailSelector = createSelector(
    demandsState,
    state => state.feedback.stepData.values.feedbackDetail
);
